import { Link as RouterLink } from 'react-router-dom';
import { Alert, AlertIcon, AlertTitle, Box, Button } from '@chakra-ui/react';
import { IRecordedInterviewEntry } from 'types';
import { Breadcrumbs, CustomHeading, IBreadcrumbLink } from 'shared-components';
import { MainColumn } from '../../../molecules/MainColumn';

interface IDeletedInterviewProps {
  interview: IRecordedInterviewEntry;
  breadcrumbItems: IBreadcrumbLink[];
}

export default function DeletedInterview(props: IDeletedInterviewProps) {
  return (
    <MainColumn>
      <Breadcrumbs items={props.breadcrumbItems} />

      <Box>
        <CustomHeading level="h1" mt={4} mb={4}>
          {props.interview.interviewName}
        </CustomHeading>

        <Alert status="error" mb={4}>
          <AlertIcon />

          <Box>
            <AlertTitle>Sorry, this interview has been deleted and is no longer available.</AlertTitle>
          </Box>
        </Alert>

        <Button as={RouterLink} to={props.breadcrumbItems[1].to}>
          Return to student page
        </Button>
      </Box>
    </MainColumn>
  );
}
